import "./HistorySync.css"
import {HistorySyncState, historySyncStore} from "../stores/HistorySyncStore";
import {observer} from "mobx-react-lite";

function HistorySync() {
    let body
    if (historySyncStore.getState() == HistorySyncState.IN_SYNC) {
        body = <>
            <div>Syncing...</div>
        </>
    }
    if (historySyncStore.getState() == HistorySyncState.SYNCED) {
        body = <>
            <div>Up to date</div>
        </>
    }

    return <>
        <div className={"history-sync-status"}>
            {body}
        </div>
    </>
}

export default observer(HistorySync)